import type { AdminOrderDetail } from '../../domain/entities/AdminOrder';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class GetAdminOrderDetailUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(orderId: string): Promise<AdminOrderDetail> {
    return this.repository.getAdminOrderDetail(orderId);
  }
}
